import Vue from 'vue';
import MdmIcon from '../components/atoms/Global/MdmIcon.vue';
Vue.component('mdm-icon', MdmIcon);